import { VIEW_CLAIMS } from '@/common/permissionConstants';
import { notifyNoPermission } from '@/common/notifyNoPermission';
import { BILLING_TABS, isBillingTabAvailable } from '@/composables/billing/useBillingTabs';
import { useFeatureFlags } from '@/composables/useFeatureFlags';

// A missing flag reads as a missing permission: same message, back to where the user was.
const unifiedBillingGuard = (to, from) => {
    const { isEnabled } = useFeatureFlags();
    if (isEnabled('unified-billing')) return undefined;
    notifyNoPermission();
    return from.name ? false : { name: 'dashboard' };
};

// A tab hidden from the tab bar is also closed by URL; it lands on Charges.
const billingTabGuard = (name) => () => {
    const tab = BILLING_TABS.find((entry) => entry.name === name);
    if (isBillingTabAvailable(tab)) return undefined;
    return { name: 'billing-charges' };
};

export default [
    {
        path: 'billing',
        component: () => import('@/views/BillingPage.vue'),
        meta: { label: 'Billing', hasPermission: VIEW_CLAIMS },
        beforeEnter: unifiedBillingGuard,
        children: [
            {
                path: '',
                name: 'billing',
                redirect: { name: 'billing-charges' },
            },
            {
                // The segment only matches its three values, so a patient id in the next slot is never read as one.
                path: 'charges/:segment(insurance|self-pay|per-diem)?/:id?/:activeDialog?/:activeId?/:activeGroupId?',
                name: 'billing-charges',
                component: () => import('@/views/billing/BillingChargesTab.vue'),
                // Only the segment: the tables read the form-dialog params from the route themselves.
                props: (route) => ({ segment: route.params.segment }),
            },
            {
                path: 'remittances',
                name: 'billing-remittances',
                component: () => import('@/views/billing/BillingRemittancesTab.vue'),
                beforeEnter: billingTabGuard('billing-remittances'),
            },
            {
                path: 'payments',
                name: 'billing-payments',
                component: () => import('@/views/PaymentsPage.vue'),
                props: { remittancesRoute: { name: 'billing-remittances' }, filesRoute: { name: 'billing-files' }, embedded: true },
                beforeEnter: billingTabGuard('billing-payments'),
            },
            {
                path: 'activity',
                name: 'billing-activity',
                component: () => import('@/views/billing/BillingActivityTab.vue'),
                beforeEnter: billingTabGuard('billing-activity'),
            },
            {
                path: 'files',
                name: 'billing-files',
                component: () => import('@/views/billing/BillingFilesTab.vue'),
                beforeEnter: billingTabGuard('billing-files'),
            },
        ],
    },
];
